<template>
  <div class="reaction-form">
    <BasicTooltip
      v-for="reaction in reactions"
      :key="reaction"
      :content="reactionTitles[reaction]"
      class="reaction-form__tooltip"
      placement="top"
      theme="dark"
    >
      <button class="reaction-form__item" @click="onClick(reaction)">
        <SvgIcon :icon="reaction" :source="$options.source" :size="24" />
      </button>
    </BasicTooltip>
  </div>
</template>

<script>
import { bem } from 'src/utils/bem.js';
import { modelValueConfig } from 'src/utils/vue.js';

import BasicTooltip from 'src/components/BasicTooltip/BasicTooltip.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

export default {
  name: 'ReactionForm',
  components: { SvgIcon, BasicTooltip },
  source: '/images/emojis-v3.svg',
  model: modelValueConfig(),
  props: {
    modelValue: {
      type: null,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    bem,
    onClick(reaction) {
      this.$emit('update:modelValue', reaction);
    },
  },

  computed: {
    reactions() {
      return [
        'angry',
        'slight_frown',
        'confused',
        'neutral_face',
        'slight_smile',
        'grinning',
        'heart_eyes',
      ];
    },

    reactionTitles() {
      return {
        angry: 'Злость',
        slight_frown: 'Досада',
        confused: 'Раздражение',
        neutral_face: 'Ничего',
        slight_smile: 'Спокойствие',
        grinning: 'Радость',
        heart_eyes: 'Восторг',
      };
    },
  },
};
</script>
